import React from 'react';
import './HeroSection.css';
import facebookIcon from '../assets/svg/fa-facebook.svg';
import instagramIcon from '../assets/svg/fa-instagram.svg';
import tiktokIcon from '../assets/svg/fa-tiktok.svg';
import youtubeIcon from '../assets/svg/fa-youtube.svg';
import heroImage from './assets/image.png';

function HeroSection({ title, text, customVisual }) {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title title-sm">{title}</h1>
          <p className="hero-paragraph">{text}</p>

          <div className="social-icons">
            <a href="#"><img src={facebookIcon} alt="Facebook" /></a>
            <a href="#"><img src={instagramIcon} alt="Instagram" /></a>
            <a href="#"><img src={tiktokIcon} alt="TikTok" /></a>
            <a href="#"><img src={youtubeIcon} alt="YouTube" /></a>
          </div>
        </div>

        <div className="hero-image-wrapper">
          {customVisual ? (
            customVisual
          ) : (
            <img src={heroImage} alt="Hero" className="hero-image" />
          )}
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
